const setObject = (_key, _data) => {
  localStorage.setItem(_key, JSON.stringify(_data));
};

const getObject = (_key) => {
  let data = localStorage.getItem(_key);

  try {
    return JSON.parse(data);
  } catch {
    return {};
  }
};

const purgeData = (_key) => {
  return localStorage.removeItem(_key);
};

const clear = () => {
  return localStorage.clear();
};

export { setObject, getObject, purgeData, clear };
